import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface DatabaseBackupResult {
  success: boolean;
  type: string;
  message: string;
  filePath: string;
}

@Injectable({ providedIn: 'root' })
export class DatabaseBackupService {
  private readonly baseUrl = `${environment.apiUrl}/database-backup`;

  constructor(private http: HttpClient) {}

  triggerDatabaseBackup(): Observable<DatabaseBackupResult> {
    return this.http.post<DatabaseBackupResult>(`${this.baseUrl}/trigger`, {});
  }
}